import clsx from 'clsx';
import { forwardRef } from 'react';
import { useIconData } from './useIconData.js';
import { getIconStyles } from './IconStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { IconSize } from './types/size.js';

// Render empty svg if no data is available
const defaultIcon = '<svg />';
const Icon = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    name,
    size = IconSize.SIZE_REGULAR,
    className,
    ...rest
  } = _ref;
  const data = useIconData(name);
  return jsx("span", {
    css: getIconStyles(size),
    ref: ref,
    className: clsx('icon', className),
    role: "img",
    "aria-hidden": "true",
    "data-id": `ICON-${name}`,
    dangerouslySetInnerHTML: {
      __html: data || defaultIcon
    },
    ...rest
  });
});
Icon.displayName = 'Icon';

export { Icon };
//# sourceMappingURL=Icon.js.map
